import type { LanguageProperty } from 'ehs-react';
import { HBox, Icon, intl } from 'ehs-react';
import React from 'react';
import { useAccessStore } from '../../store/access.store';
import shallow from 'zustand/shallow';
import { usePortletStore } from '../../App';

export function CustomErrorMessage(): JSX.Element {
  const [isBlocked, errorLanguageKey] = useAccessStore(
    state => [state.blocked, state.errorLanguageKey],
    shallow
  );

  const errorMessageOnRedirect = usePortletStore(
    state => state.configuration.errorMessageOnRedirect
  );

  const shouldShowError = () => isBlocked || errorMessageOnRedirect;

  return shouldShowError() ? (
    <HBox
      className="error-inline-notification"
      role="alert"
      align="flex-start"
      aria-describedby="pin-based-error"
    >
      <div className="header-wrapper">
        <div>
          <Icon iconName="cancel" aria-label="" />
        </div>
      </div>
      <div className="default">
        <p id="pin-based-error">
          {errorMessageOnRedirect
            ? intl(errorMessageOnRedirect as LanguageProperty)
            : intl(errorLanguageKey)}
        </p>
      </div>
    </HBox>
  ) : (
    <></>
  );
}
